import React, { useState, useEffect, useRef } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

// ------------------ COMPONENTES DE BASE--------------------------
import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { obtenerCountries } from "../../../../../Base/API/Global/Countries/CountriesRequests";
import Loader from "../../../../../Base/Components/Loader/Loader";

// ------------------- CONSULTAS A LA API---------------------------
import {getCustomers, addCustomers} from "../../../../../API/Compras/Customers/CustomerRequests";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";


const CrudCustomersModal = ({
  customer,
  customerDialog,
  setCustomerDialog,
  toastRef,
  getCustomer,
  modo,
}) => {

  const toastDialog = useRef(null);
  const toast = useRef(null);

  const [show, setShow] = useState(false);
  const [customers, setCustomer] = useState([{}]);
  const [paises, setPaises] = useState([{}]);
  const [estados, setEstados] = useState([{}]);
  const [loading, setLoading] = useState(false);

  //formato de fecha  
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear().toString().slice(-2); // Obtener solo los últimos dos dígitos del año
    let hours = date.getHours();
    const meridiem = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convertir las horas al formato de 12 horas
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);
  
    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${meridiem}`;
  };
  

  const initialValues = {
    IdCustomer: -1,
    IdStatus: "",
    RTN: "",
    CustomerName: "",
    CodigoCliente: "",
    Address: "",
    IdCountry: "",
    DateCreate: formatDate(new Date()),
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const cust = await getCustomers();
    const estadosTempo = await getEstadosCategory("General");
    const pais = await obtenerCountries();

    setCustomer(cust);
    setEstados(estadosTempo);
    setPaises(pais);

    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === customer?.IdStatus);

    setValues({
      ...customer,
      Estado: estadoInicial,
      DateCreate: modo === "Crear" ? formatDate(new Date()) : formatDate(customer.DateCreate),
      Pais: pais.find((p) => customer?.IdCountry === p.IdCountry),
    });
    setLoading(false)
  };

  const onHide = () => {
    setCustomerDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.CustomerName) {
      error.CustomerName = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarCustomer = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const nombreActual = values?.CustomerName?.trim()?.toLowerCase();

      const existingProveedor = customers.find((pr) => {
        const mismoNombre = pr.CustomerName?.trim()?.toLowerCase() === nombreActual;
        const esOtroCliente = Number(pr.IdCustomer) !== Number(values.IdCustomer);

        return mismoNombre && esOtroCliente;
      });

      if (existingProveedor) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe un registro con ese nombre."
        );
      } else {
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          IdCustomer: values?.IdCustomer,
          IdStatus: estadoId,
          RTN: values.RTN,
          CustomerName: values.CustomerName,
          CodigoCliente: values.CodigoCliente,
          Address: values.Address,
          IdCountry: values.Pais?.IdCountry,
          DateCreate: values.DateCreate,
        };
        // console.log(a);
        const t = await addCustomers(a);
        if (modo === "Crear") {
          onHide();
          toastShow(
            toastRef,
            "success",
            "Datos Agregados",
            "Customer agregado exitosamente."
          );
          getCustomer();
        } else {
          onHide();
          toastShow(
            toastRef,
            "success",
            "Datos Actualizados",
            "Customer actualizado exitosamente."
          );
          getCustomer();
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Actualizar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarCustomer();
          } else {
            agregarCustomer();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (customerDialog) {
      getValoresIniciales();
    }
  }, [customerDialog]);

  const dialogTitle = modo === "Crear" ? "Nuevo Cliente" : "Actualizar Cliente";

  return (
    <div>
      <Toast ref={toast} style={{ zIndex: 50000 }} />
      <Dialog
        visible={customerDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
        <Loader loading={loading} querySelector={"#Dialog"} />
        <div style={{ width: "100", margin: "auto" }}>
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
            <h1 className="fw-bold">{values.CodigoCliente}</h1>
          </div>
          <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="CustomerName"
                  value={values.CustomerName}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.CustomerName ? "p-invalid" : ""}
                />
                <label htmlFor="CustomerName">Nombre Cliente</label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="RTN"
                  value={values.RTN}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
                <label htmlFor="RTN">RTN</label>
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Pais"}
                  value={values.Pais}
                  items={paises}
                  field={"Country"}
                  label={"País"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
              </span>
            </div>

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <InputText
                  name="Address"
                  value={values.Address}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
                <label htmlFor="Minimo">Dirección</label>
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estado"}
                  value={values.Estado}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdStatus ? "p-invalid" : ""}
                />
              </span>
            </div>

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <InputText
                  name="DateCreate"
                  value={values.DateCreate}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  readOnly
                  label={"Fecha"}
                />
                <label htmlFor="DateCreate">Fecha de Creación</label>
              </span>
            </div>
          </div>
        </div>

        </div>
      </Dialog>
    </div>
  );
};

export default CrudCustomersModal;
